module.exports = __webpack_public_path__ + "static/media/certificate-fill.34af3be7.svg";